<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="omschrijving">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Omschrijving </th>
        <td mat-cell *matCellDef="let row"> {{row.omschrijving}} </td>
    </ng-container>

</mg-table>
